export const TEXT_COLORS = [
  { value: null, label: 'Domyślny' },
  { value: '#111827', label: 'Czarny' },
  { value: '#6B7280', label: 'Szary' },
  { value: '#DC2626', label: 'Czerwony' },
  { value: '#EA580C', label: 'Pomarańczowy' },
  { value: '#CA8A04', label: 'Żółty' },
  { value: '#16A34A', label: 'Zielony' },
  { value: '#2563EB', label: 'Niebieski' },
  { value: '#7C3AED', label: 'Fioletowy' },
];

export const HIGHLIGHT_COLORS = [
  { value: null, label: 'Brak' },
  { value: '#FEF08A', label: 'Żółty' },
  { value: '#BBF7D0', label: 'Zielony' },
  { value: '#BFDBFE', label: 'Niebieski' },
  { value: '#FBCFE8', label: 'Różowy' },
  { value: '#FED7AA', label: 'Pomarańczowy' },
  { value: '#E5E7EB', label: 'Szary' },
];
